import React from 'react'
import GetParentForm from './GetParentForm'
import ParentNav from './ParentNav'

export default function Parent() {
  return (
    <div>
      <ParentNav/>
      <GetParentForm/>
    </div>
  )
}
